<template>
    <div class="bg-light-grey m-t-3 crossGarantie" v-if="items.length > 0">
        <div class="widget-inner">
            <div class="sub-headline mb-4">
                {{ $translate("Servershop5::Template.garantieempfehlung") }}
            </div>
            <div class="hide-more-items" ref="hidding" :id="'hidden_'+this._uid+10">
                <ul class="product-list row grid categoryItem">
                   <template v-for="item in items">
                        <li class="col-12 col-sm-6 col-md-4 col-lg-3">
                            <category-item
                                    :item-data="item.data"
                                    :decimal-count="2">
                            </category-item>
                        </li>
                    </template>
                </ul>
            </div>
            <button class="showMore btn btn-dark-blue mx-auto d-flex mt-3">
                <span>
                    {{ $translate("Servershop5::Template.ShowMoreItemsOfGarantie") }}
                </span>
                <span>
                    {{ $translate("Servershop5::Template.ShowLessItemsOfGarantie") }}
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    export default
    {
        props: ["template"],
        data: function()
        {
            return {
                items:[],
                open:false,
                originalHeight:0,
                expandedHeight:0
            };
        },
        mounted: function()
        {
            vueEventHub.$on("garantie-item", data =>
            {
                this.getItems(data);
                this.$store.commit("setGarantie", data);
            });
            vueEventHub.$on("crossGarantie", data =>
            {
              this.open = data
            });
        },
        methods:
        {
            getItems:function(data)
            {
                let _self = this;
                for(let i =0; i < data.group.groups.length; i++)
                {
                    for(let i2 =0; i2 < data.group.groups[i].items.length; i2++)
                    {
                        _self.items.push(data.group.groups[i].items[i2]);
                    }
                }
            }
        },
        computed:
        {
            garantieItems:   function()
            {
                let _self = this;
                return _self.items;
            }
        }
    }
</script>


